import styled, { css } from "styled-components";
import { getIconSize } from "utils/text-styles";

const alertTypeStyles = (type: string) => css`
  background-color: ${(props) =>
    props.theme.theme.ALERT.BACKGROUND[type.toUpperCase()]} !important;
  color: ${(props) =>
    props.theme.theme.ALERT.TEXT[type.toUpperCase()]} !important;

  p,
  h6,
  .close-button {
    color: ${(props) =>
      props.theme.theme.ALERT.TEXT[type.toUpperCase()]} !important;
  }
`;

export const AlertContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid ${(props) => props.theme.theme.DIVIDER_COLOR} !important;

  .alert-content {
    padding: 1rem;
  }

  &.alert-danger {
    ${alertTypeStyles("error")}
  }

  &.alert-info {
    ${alertTypeStyles("info")}
  }

  &.alert-success {
    ${alertTypeStyles("success")}
  }

  &.alert-warning {
    ${alertTypeStyles("warning")}
  }
`;

export const AlertIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  .cl {
    font-size: ${(props) => getIconSize(props.theme.fontSize)} !important;
  }

  &.alert-danger {
    color: ${(props) => props.theme.theme.ALERT.TEXT.ERROR} !important;
  }

  &.alert-info {
    color: ${(props) => props.theme.theme.ALERT.TEXT.INFO} !important;
  }

  &.alert-success {
    color: ${(props) => props.theme.theme.ALERT.TEXT.SUCCESS} !important;
  }

  &.alert-warning {
    color: ${(props) => props.theme.theme.ALERT.TEXT.WARNING} !important;
  }
`;

export const AlertContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const AlertCloseButton = styled.button`
  border: none;
  cursor: pointer;
  appearance: none;
  background: none;

  color: ${(props) => props.theme.theme.ALERT.TEXT.CLOSE} !important;
`;
